export const cocktailTransformer = (cocktail) => {
  return cocktail?.__transformed__
    ? cocktail
    : (() => {
        const averageScore =
          Math.round(cocktail.reviews_aggregate?.aggregate?.avg?.score * 10) /
          10;
        delete cocktail.reviews_aggregate;
        return {
          ...cocktail,
          averageScore,
          recipes: (cocktail.recipes || []).map((r) => ({
            ...r,
            timeline: {
              ...r.timeline,
              steps: (r.timeline || { steps: [] }).steps.map((s) => ({
                ...s,
                equipments: s.equipments?.map((e) => e.equipment),
                ingredients: s.ingredients.map((i) => {
                  const ingredient = i.ingredient;
                  return {
                    ...ingredient,
                    measurements: i.measurements,
                    numCocktails:
                      ingredient.recipe_timeline_step_ingredients_aggregate
                        ?.aggregate?.count || 0,
                    isSpecific:
                      !!!ingredient.is_parent && !!ingredient.brand_id,
                  };
                }),
              })),
            },
          })),
          __transformed__: true,
        };
      })();
};
